<template>
    <el-dialog :title="title"
               :visible="visible"
               center
               :width="controlWidth"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @close="onClose"
               :top="top">

      <tool-bar :operation="operation"
                v-if="operation.search"
                :message = "message"
                :upload-url="url.import"
                @search="onSearch"
                :form="queryParams"
                @uploaded="onUploaded"
                @export="onExport">
        <slot name="toolbar"></slot>
        <slot slot="simple-search" name="toolbar-simple-search"></slot>
        <slot slot="buttons" name="buttons"></slot>
      </tool-bar>
      <paging :url="url.list" :params="queryParams" ref="grid"  @loaded="onLoaded">
        <template slot-scope="grid">
          <slot name="grid" :data="grid.data" :loading="grid.loading"></slot>
        </template>
      </paging>
      <span slot="footer" class="dialog-footer">
        <slot name="footer">

        </slot>
    </span>
    </el-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'

  import PagingGrid from '@/tycomponents/Grid/PagingGrid';
  import Paging from '@/tycomponents/Grid/Paging'
  import ToolBar from '@/tycomponents/Grid/ToolBar';
    export default {
      components: {
        PagingGrid,ToolBar,Paging
      },
      props:{
        formTemplate: {
          type: Array,
          default: () => []
        },
        message: {
          type: String
        },
        title:{
          type:String
        },
        visible:{
          type:Boolean
        },
        queryParams: {
          type: Object
        },
        url: {
          type: Object,
          default: () => {
          }
        },
        name: {
          type: String
        },
        operation: {
          type: Object
        },
        top:{
          type:String,
          default:'15vh'
        },
        width:{
          type:String
        },
        CustomId:{
          type:String
        }
      },
      data(){
        return {
          loading: false,
        }
      },
      methods:{
        ...mapGetters('rights', ['canQuery', 'canAdd', 'canEdit', 'canDelete', 'canImport', 'canExport']),
        // onselectionChange(val) {
        //   this.selection = val;
        // },
        onClose() {
          this.$emit('update:visible', false);
        },
        /*onSearch() {
          this.queryParams.CustomId = this.CustomId;
          this.$refs['grid'].reload();
        },*/
        loadRow(row, id) {
          let self = this;
          if(id != undefined && id != null && self.url.get != undefined) {
            self.loading = true;
            self.$http.post(self.url.get, {
              Data: id
            }).then(result => {
              if (result.State == 1) {
                for(var i in self.form){
                  if(result.Data[i] != undefined){
                    self.form[i] = result.Data[i];
                  }
                }
                self.$emit("onEditDataLoaded", self.form);
              } else {
                self.$message.error(result.Message);
              }
              self.loading = false;
            }, () => {
              self.loading = false;
              self.$message.error('数据加载失败，请检查您的网络是否可用。');
            });
          }
        },
        reload(url){
          this.$refs['grid'].reload(url);
        },
        onUploaded(res, file) {
          this.$emit("uploaded", res, file);
        },
        onSearch() {
          this.$nextTick(()=>{
            this.$refs['grid'].reload();
          })
        },
        onLoaded() {
          // 触发事件
          this.$emit('loaded');
        },
        loadData() {
          this.$refs['grid'].loadData();
        },
        onExport() {
          this.$emit('export');
        },
        onShow() {
          this.$emit('onShow');
        }
      },
      computed:{
        controlWidth() {
          return this.width
        },
      },
      watch: {
        visible(val) {
          if(val) {
            this.loading = true;
            this.onShow();
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/tycomponents/Dialog/DialogTable.vue